import { Component, OnInit, OnDestroy, Output, EventEmitter, Injectable } from '@angular/core';
import { LeaveService } from '../../leave/services/leave.service';
import { Router } from '@angular/router';
import { LeaveModel } from '../../leave/entities/LeaveModel';
import { TaskSaveService } from '../../task/services/task-save.service';
import { ActuationService } from '../services/actuation.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { LeaveOperations } from 'app/modules/common/enums/leave-operations';
import { EmployeeService } from 'app/modules/employee/services/employee.service';

@Injectable()
@Component({
    selector: 'app-bajas',
    templateUrl: './bajas.component.html',
    styleUrls: ['./bajas.component.scss'],
    standalone: false
})
export class BajasComponent implements OnInit, OnDestroy {

  LeaveList: Array<LeaveModel>;
  LeaveOperations = LeaveOperations;

  PermissionList: Array<string>;
  public EmployeeId: number;

  @Output() subSelectedBaja: EventEmitter<any> = new EventEmitter<any>();
  subscription: any;
  resultArray: any[] = [];
  DateDiff: number;
  constructor(
    public leaveService: LeaveService,
    private taskService: TaskSaveService,
    private actuationService: ActuationService,
    public router: Router,
    public sharedService: SharedService,
    private employeeService: EmployeeService) {

  }

  ngOnInit(): void {
    this.leaveService.SubscribeLeaves();
    this.EmployeeId = Number(localStorage.getItem('EmplooyeeID'));

    this.employeeService.EmployeeId.subscribe(id => {
      if(id) {
        this.EmployeeId = id;
      }
    });
    this.OnEmployeeLeaveSelect(0);
    var leaveId = localStorage.getItem('LeaveID');
    if (leaveId !== null) {
      this.employeeService.InitEmployeeWarning(this.EmployeeId, leaveId);
    }
  }

  ngOnDestroy(): void {
     this.leaveService.UnsubscribeLeaves();
  }

  OnEmployeeLeaveSelect(leaveId): void {
    this.leaveService.SelectedRowId = leaveId;
    this.leaveService.PublishEmployeeLeaveDetails(leaveId, this.EmployeeId);
    this.taskService.PublishTasks(leaveId);
    this.actuationService.PublishActuations(leaveId);
    if (leaveId != 0) {
      this.employeeService.InitEmployeeWarning(this.EmployeeId, leaveId);
    }
  }
}
